import React from "react";
import PropTypes from "prop-types";
import { StaticImage } from "gatsby-plugin-image";
import cn from "clsx";
import { Container, Row, Col } from "@ui/wrapper";
import Text from "@ui/text";
import Anchor from "@ui/anchor";
import Button from "@ui/button";
import Heading from "@ui/heading";
import Social, { SocialLink } from "@ui/social";
import { SocialType } from "@utils/types";
import {
    FooterWrap,
    FooterTop,
    FooterWidget,
    LogoWidget,
    TextWidget,
    FooterWidgetList,
    FooterBottom,
} from "./style";

const Footer = ({ data }) => {
    return (
        <FooterWrap>
            <FooterTop>
                <Container>
                    <Row>
                        <Col lg={3} sm={5}>
                            <FooterWidget mb={["31px", null, null, 0]}>
                                <LogoWidget>
                                    <StaticImage
                                        src="../../../assets/images/logo/dark-logo-160x48.png"
                                        alt="logo"
                                        width={160}
                                        height={48}
                                    />
                                </LogoWidget>
                                {data?.contact && (
                                    <TextWidget>
                                        {data.contact?.address && (
                                            <Text mb="10px">
                                                {data.contact.address}
                                            </Text>
                                        )}
                                        {data.contact?.email && (
                                            <Text mb="10px">
                                                <Anchor
                                                    path={`mailto:${data.contact.email}`}
                                                    color="text"
                                                    $hover={{ layout: 2 }}
                                                >
                                                    {data.contact.email}
                                                </Anchor>
                                            </Text>
                                        )}
                                        {data.contact?.phone && (
                                            <Text mb="10px">
                                                <Anchor
                                                    path={`tel:${data.contact.phone}`}
                                                    fontWeight="800"
                                                    color="heading"
                                                    $hover={{ layout: 2 }}
                                                >
                                                    {data.contact.phone}
                                                </Anchor>
                                            </Text>
                                        )}
                                        {data.contact?.website && (
                                            <Text mb="10px">
                                                <Anchor
                                                    path={data.contact.website}
                                                    $hover={{ layout: 2 }}
                                                >
                                                    {data.contact.website}
                                                </Anchor>
                                            </Text>
                                        )}
                                    </TextWidget>
                                )}
                                <div>
                                    <StaticImage
                                        src="../../../assets/images/footer/ruishendownload128.png"
                                        alt="九荣智控APP 下载"
                                        width={128}
                                        height={128}
                                    />
                                    <Text>九荣智控APP 下载</Text>
                                </div>
                            </FooterWidget>
                        </Col>
                        <Col lg={2} md={4} sm={6}>
                            <FooterWidget>
                                <Heading as="h6" mt="-3px" mb="20px">
                                    解决方案
                                </Heading>
                                <FooterWidgetList>
                                    <li>
                                        <Anchor
                                            path="/hardware-product#sensor"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            数据采集
                                        </Anchor>
                                    </li>
                                    <li>
                                        <Anchor
                                            path="/hardware-product#control"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            智能控制
                                        </Anchor>
                                    </li>
                                    <li>
                                        <Anchor
                                            path="/hardware-product#gateway"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            物联网网关
                                        </Anchor>
                                    </li>
                                    <li>
                                        <Anchor
                                            path="/hardware-product#edge-computing"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            边缘计算
                                        </Anchor>
                                    </li>
                                    <li>
                                        <Anchor
                                            path="/"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            物联网设备管理
                                        </Anchor>
                                    </li>
                                    <li>
                                        <Anchor
                                            path="/"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            资产建模
                                        </Anchor>
                                    </li>
                                    <li>
                                        <Anchor
                                            path="/solution/asset-management"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            资产管理
                                        </Anchor>
                                    </li>
                                    <li>
                                        <Anchor
                                            path="/solution/predictive-maintenance"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            预测性维护
                                        </Anchor>
                                    </li>
                                    <li>
                                        <Anchor
                                            path="/solution/modeling-analysis-engine"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            GIS+BIM模型
                                        </Anchor>
                                    </li>
                                    <li>
                                        <Anchor
                                            path="/solution/spatial-map"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            一张图
                                        </Anchor>
                                    </li>
                                </FooterWidgetList>
                            </FooterWidget>
                        </Col>
                        <Col lg={2} md={4} sm={6}>
                            <FooterWidget mb={["31px", null, null, 0]}>
                                <Heading as="h6" mt="-3px" mb="20px">
                                    行业应用
                                </Heading>
                                <FooterWidgetList>
                                    <li>
                                        <Anchor
                                            path="/asset-domain/dynamic-sensor"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            动传感器
                                        </Anchor>
                                    </li>
                                    <li>
                                        <Anchor
                                            path="/asset-domain/sdm-studio"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            二次开发平台
                                        </Anchor>
                                    </li>
                                    <li>
                                        <Anchor
                                            path="/asset-domain/waterquality-monitoring"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            水质监测
                                        </Anchor>
                                    </li>
                                    <li>
                                        <Anchor
                                            path="/asset-domain/waterlogging-monitoring"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            内涝监测
                                        </Anchor>
                                    </li>
                                    <li>
                                        <Anchor
                                            path="/asset-domain/flow-monitoring"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            流量监测
                                        </Anchor>
                                    </li>
                                    <li>
                                        <Anchor
                                            path="/asset-domain/irrigation-pumpstation"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            智慧灌溉
                                        </Anchor>
                                    </li>
                                    <li>
                                        <Anchor
                                            path="/asset-domain/urban-hydrology"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            城市水文
                                        </Anchor>
                                    </li>
                                    <li>
                                        <Anchor
                                            path="/asset-domain/pumpStation-control"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            泵站控制
                                        </Anchor>
                                    </li>
                                </FooterWidgetList>
                            </FooterWidget>
                        </Col>
                        <Col lg={2} md={4} sm={6}>
                            <FooterWidget mb={["27px", null, 0]}>
                                <Heading as="h6" mt="-3px" mb="20px">
                                    服务
                                </Heading>
                                <FooterWidgetList>
                                    <li>
                                        <Anchor
                                            path="/our-services#private-cloud-deployment"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            私有云部署
                                        </Anchor>
                                    </li>
                                    <li>
                                        <Anchor
                                            path="/our-services#on-prem-deployment"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            本地部署
                                        </Anchor>
                                    </li>
                                    <li>
                                        <Anchor
                                            path="/our-services#data-analytics"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            数据服务
                                        </Anchor>
                                    </li>
                                    <li>
                                        <Anchor
                                            path="/our-services#modeling-service"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            建模服务
                                        </Anchor>
                                    </li>
                                </FooterWidgetList>
                            </FooterWidget>
                        </Col>
                        <Col lg={3} md={5}>
                            <FooterWidget>
                                <Heading as="h6" mt="-3px" mb="20px">
                                    支持
                                </Heading>
                                <FooterWidgetList>
                                    <li>
                                        <Anchor
                                            path="/privacy"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            隐私申明
                                        </Anchor>
                                    </li>
                                    <li>
                                        <Anchor
                                            path="/contact-us"
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            联系我们
                                        </Anchor>
                                    </li>
                                    <li>
                                        <Anchor
                                            color="text"
                                            $hover={{ layout: 2 }}
                                        >
                                            <a href="http://www.jlongkj.com">
                                                宁波九荣智控有限公司
                                            </a>
                                        </Anchor>
                                    </li>
                                </FooterWidgetList>
                            </FooterWidget>
                        </Col>
                    </Row>
                </Container>
            </FooterTop>
            <FooterBottom>
                <Container>
                    <Row alignItems="center">
                        <Col md={12} textAlign={["center", null, "center"]}>
                            {data?.copyright && (
                                <Text pb={["15px", 0]}>
                                    &copy; {new Date().getFullYear()}{" "}
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: data.copyright,
                                        }}
                                    />
                                </Text>
                            )}
                        </Col>
                    </Row>
                </Container>
            </FooterBottom>
        </FooterWrap>
    );
};

Footer.propTypes = {
    data: PropTypes.shape({
        socials: PropTypes.arrayOf(PropTypes.shape(SocialType)),
        copyright: PropTypes.string,
        contact: PropTypes.shape({
            phone: PropTypes.string,
            email: PropTypes.string,
            address: PropTypes.string,
            website: PropTypes.string,
        }),
    }),
};

export default Footer;

// <Col md={6} textAlign={["center", null, "right"]}>
//     {data?.socials && (
//         <Social
//             space="16px"
//             tooltip={true}
//             shape="rounded"
//             variant="outlined"
//         >
//             {data.socials.map((social) => (
//                 <SocialLink
//                     key={social.id}
//                     path={social.link}
//                     title={social.title}
//                 >
//                     <i
//                         className={cn(
//                             social.icon,
//                             "link-icon"
//                         )}
//                     ></i>
//                 </SocialLink>
//             ))}
//         </Social>
//     )}
// </Col>
